import { render, staticRenderFns } from "./simple-layout.vue?vue&type=template&id=ffa32040"
import script from "./simple-layout.vue?vue&type=script&lang=js"
export * from "./simple-layout.vue?vue&type=script&lang=js"
import style0 from "./simple-layout.vue?vue&type=style&index=0&id=ffa32040&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports